import "./env.bootstrap";
import "leaflet/dist/leaflet.css";
import "leaflet/dist/leaflet.css";
import "leaflet-draw/dist/leaflet.draw.css";
import "./leaflet-fix";
import "vis-timeline/styles/vis-timeline-graph2d.min.css";
import * as Sentry from "@sentry/react";

import React from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { store } from "./shared/store/store";
import { AppDev } from "./root/App.dev";
import { AppProd } from "./root/App.prod";
import { I18nProvider } from "@racoon/i18n";
import { ToastProvider, ModalProvider, GlobalErrorToaster } from "@racoon/ui";
import "@racoon/ui/globals.css";
import { TopLoader } from "./components/top-loader";

try {
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    sendDefaultPii: true,
  });
} catch (error) {
  console.error("Sentry initialization failed:", error);
}

createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <Provider store={store}>
      <I18nProvider>
        <ToastProvider>
          <GlobalErrorToaster />
          <ModalProvider>
            <TopLoader />
            {import.meta.env.DEV ? <AppDev /> : <AppProd />}
          </ModalProvider>
        </ToastProvider>
      </I18nProvider>
    </Provider>
  </React.StrictMode>,
);
